import rulePoint from "@/components/rule/rulePoint";
import rulePoints from "@/components/rule/rulePoints";
import ruleFence from "@/components/rule/ruleFence";
import ruleLine from "@/components/rule/ruleLine";
import ruleCount from "@/components/rule/ruleCount";
import ruleSpeed from "@/components/rule/ruleSpeed";
import ruleNotice from "@/components/rule/ruleNotice";
import ruleStay from "@/components/rule/ruleStay";
import rulePost from "@/components/rule/post";
import ruleFatigue from "@/components/rule/fatigue";
var data = [
  {
    path: "/rulePushNotice",
    component: () => import("@/components/rule/rulePushNotice"),
  },
  {
    path: "/rulePoint",
    component: rulePoint,
  },
  {
    path: "/rulePoints",
    component: rulePoints,
  },
  {
    path: "/ruleLine",
    component: ruleLine,
  },
  {
    path: "/ruleFence",
    component: ruleFence,
  },
  {
    path: "/ruleSpeed",
    component: ruleSpeed,
  },
  {
    path: "/ruleCount",
    component: ruleCount,
  },
  {
    path: "/ruleNotice",
    component: ruleNotice,
  },
  {
    path: "/ruleStay",
    component: ruleStay,
  },
  {
    path: "/post",
    component: rulePost,
  },
  {
    path: "/fatigue",
    component: ruleFatigue,
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/rule.js